module.exports = __webpack_public_path__ + "img/anonym.d0265dd4.png";